import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  return <section id="inicio" className="bg-navy text-white pt-24 pb-16 md:pt-32 md:pb-24" data-id="element-57">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-58">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-59">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-60">
            <div className="w-16 h-1 bg-gold mb-6" data-id="element-61"></div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-3 leading-tight" data-id="element-62">
              {t('hero.headline')}
            </h1>
            <p className="text-xl md:text-2xl text-gold font-semibold mb-6" data-id="element-63">
              {t('hero.subheadline')}
            </p>
            <p className="text-lg md:text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-64">
              {t('hero.description')}
            </p>
            <div className="flex flex-col items-center sm:items-start gap-4" data-id="element-65">
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-66">
                <Link to="/contacto" className="bg-gold text-navy px-8 py-4 rounded-md font-semibold text-center hover:bg-opacity-90 transition-all shadow-lg" data-id="element-67">
                  {t('hero.cta.primary')}
                </Link>
                <Link to="/contacto" className="bg-gold text-navy px-8 py-4 rounded-md font-semibold text-center hover:bg-opacity-90 transition-all shadow-lg" data-id="element-68">
                  {t('hero.cta.secondary')}
                </Link>
              </div>
              <button onClick={() => document.getElementById('visita')?.scrollIntoView({
              behavior: 'smooth'
            })} className="bg-gold text-navy px-8 py-4 rounded-md font-semibold text-center hover:bg-opacity-90 transition-all shadow-lg" data-id="element-69">
                {t('hero.cta.tertiary')}
              </button>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-70">
            <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&q=80" alt="Profesionales de negocios" className="rounded-lg shadow-2xl w-full" data-id="element-71" />
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-gold opacity-20 rounded-lg -z-10" data-id="element-72"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}